import React, { useEffect, useState, createElement } from 'react';
import { WebinarPage } from './pages/WebinarPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { ThankYouPurchasePage } from './pages/ThankYouPurchasePage';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
function initMetaPixel() {
  if (window.fbq) return;
  const n: any = window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(t);
  window.fbq('init', '1735417077435461');
  window.fbq('track', 'PageView');
}
function getRoute(): string {
  const pathname = window.location.pathname;
  const hash = window.location.hash.replace('#', '');
  if (pathname === '/thank-you-purchase' || hash === '/thank-you-purchase') {
    return '/thank-you-purchase';
  }
  if (pathname === '/thank-you' || hash === '/thank-you') {
    return '/thank-you';
  }
  return '/';
}
export function App() {
  const [route, setRoute] = useState(getRoute);
  // Initialize Meta Pixel on mount
  useEffect(() => {
    initMetaPixel();
  }, []);
  // Fire PageView on route changes
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [route]);
  useEffect(() => {
    function onRouteChange() {
      setRoute(getRoute());
    }
    window.addEventListener('hashchange', onRouteChange);
    window.addEventListener('popstate', onRouteChange);
    return () => {
      window.removeEventListener('hashchange', onRouteChange);
      window.removeEventListener('popstate', onRouteChange);
    };
  }, []);
  if (route === '/thank-you-purchase') {
    return <ThankYouPurchasePage data-id="element-0" />;
  }
  if (route === '/thank-you') {
    return <ThankYouPage data-id="element-1" />;
  }
  return <WebinarPage data-id="element-2" />;
}